import { render, staticRenderFns } from "./BonusSendConfigPane.vue?vue&type=template&id=8eec82fa&scoped=true"
import script from "./BonusSendConfigPane.vue?vue&type=script&lang=js"
export * from "./BonusSendConfigPane.vue?vue&type=script&lang=js"
import style0 from "./BonusSendConfigPane.vue?vue&type=style&index=0&id=8eec82fa&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eec82fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8eec82fa')) {
      api.createRecord('8eec82fa', component.options)
    } else {
      api.reload('8eec82fa', component.options)
    }
    module.hot.accept("./BonusSendConfigPane.vue?vue&type=template&id=8eec82fa&scoped=true", function () {
      api.rerender('8eec82fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/BonusSend/BonusSendConfigPane.vue"
export default component.exports